import React from 'react';

import { Center, Loader, Stack } from '@mantine/core';
import AlreadyPurchasedNotice from 'components/SalesPortal/AlreadyPurchasedNotice';
import SalesPortalBillingPlan from 'components/SalesPortal/SalesPortalBillingPlan';
import { useAuth } from 'context/auth-context';
import useAthleteSalesPortalBillingPlan from 'hooks/salesPortal/useAthleteSalesPortalBillingPlan';
import useAthleteSalesPortalPackage from 'hooks/salesPortal/useAthleteSalesPortalPackage';
import BackHeader from 'layouts/MobileLayout/components/BackHeader';
import NotFound from 'pages/shared/NotFound';
import { useParams } from 'react-router-dom';

import CheckoutController from './components/CheckoutController';

const SalesPortalBillingPlanPage = (): JSX.Element => {
  const { packageId, billingPlanId } = useParams<{
    packageId: string;
    billingPlanId: string;
  }>();
  const { session } = useAuth();

  const {
    data: packageData,
    isError: packageError,
    isLoading: packageLoading,
  } = useAthleteSalesPortalPackage(packageId, session?.profile?.profileId);

  const {
    data: billingPlanData,
    isError: billingPlanError,
    isLoading: billingPlanLoading,
  } = useAthleteSalesPortalBillingPlan(billingPlanId);

  if (packageLoading || billingPlanLoading) {
    return (
      <Center sx={{ flexGrow: 1 }} p='lg'>
        <Loader />
      </Center>
    );
  }

  if (
    packageError ||
    billingPlanError ||
    (packageData && packageData.data.athleteSalesPortalStatus === 'DISABLED') ||
    (billingPlanData && billingPlanData.data.athleteSalesPortalStatus === 'DISABLED')
  ) {
    return <NotFound />;
  }

  const alreadyPurchased = Boolean(packageData?.data.alreadyPurchased);

  return (
    <>
      <BackHeader title={'Explore Packages'} />
      <Stack className='content'>
        <SalesPortalBillingPlan
          gym={packageData?.data.gym}
          packageData={packageData?.data}
          billingPlanData={billingPlanData?.data}
        />
      </Stack>

      {alreadyPurchased && <AlreadyPurchasedNotice />}

      {!alreadyPurchased && billingPlanData?.data && packageData?.data && (
        <CheckoutController packageData={packageData.data} billingPlan={billingPlanData?.data} />
      )}
    </>
  );
};

export default SalesPortalBillingPlanPage;
